import * as yup from "yup";

const validations = yup.object().shape({
  dayoffTypeId: yup.number().moreThan(0, "Bu alan zorunludur"),
  proxyUserId: yup.number().moreThan(0, "Bu alan zorunludur"),
  dayoffLocation: yup.string().required("Bu alan zorunludur"),
});

export default validations;
